export enum TicketStatusGroup {
  New = 'New',
  InProgress = 'InProgress',
  Completed = 'Completed',
}

export const TicketStatusColors = {
  [TicketStatusGroup.New]: '#2E7D32',
  [TicketStatusGroup.InProgress]: '#8b5cf6',
  [TicketStatusGroup.Completed]: '#0288D1',
};

const COMPLETED_KEYWORDS = [
  'closed',
  'complete',
  'completed',
  'done',
  'resolved',
  'fixed',
  'solved',
  'finished',
  'cancelled',
  'canceled',
  'rejected',
  'declined',
  'archived',
  'finalized',
  'implemented',
  'delivered',
  'released',
];

const NEW_KEYWORDS = [
  'new',
  'active',
  'created',
  'open',
  'opened',
  'incoming',
  'unassigned',
  'not responded',
  'no response',
  'awaiting assignment',
  'new request',
  'new ticket',
  'just created',
  'pending triage',
];

export const resolveTicketStatusGroup = (
  status?: string
): TicketStatusGroup => {
  if (!status) return TicketStatusGroup.InProgress;

  const normalized = status.toLowerCase();

  if (COMPLETED_KEYWORDS.some(k => normalized.includes(k))) {
    return TicketStatusGroup.Completed;
  }

  if (NEW_KEYWORDS.some(k => normalized.includes(k))) {
    return TicketStatusGroup.New;
  }

  return TicketStatusGroup.InProgress;
};
